import React, { FC } from 'react';
import './style.scss';

const DropDownItemDivider: FC = () => {
  return <li className="horizontal-line"></li>;
};

export default DropDownItemDivider;
